<template>
  <div class="model-doc-tab">
    <el-tabs type="border-card" v-model="activeTabName">
      <el-tab-pane label="属性" name="attr">
        <el-table :data="attrList">
          <el-table-column type="index" label="序号" width="80"/>
          <el-table-column prop="attribute_name" label="属性名"/>
          <el-table-column prop="attribute_value" label="属性值"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="预览" name="preview" v-if="!isFolder">
        <FrameIframe
            v-if="docData.file_id"
            :file-id="docData.file_id"
            :key="docData.file_id"
            class="frame"></FrameIframe>
        <div v-else>
          没有文件
        </div>
      </el-tab-pane>
      <el-tab-pane label="物料BOM" name="bom">
        物料BOM
      </el-tab-pane>
      <el-tab-pane label="包含" name="used">
        <el-table :data="usedDocList">
          <el-table-column type="index" label="序号" width="80"/>
          <el-table-column prop="name" label="名称"/>
          <el-table-column prop="doc_type_name" label="类型"/>
          <el-table-column prop="ref_count" label="包含数量"/>
          <el-table-column prop="version" label="版本号"/>
          <el-table-column prop="status_name" label="版本状态"/>
          <el-table-column prop="checkout_out_status_name" label="检出状态"/>
          <el-table-column prop="checkout_user_name" label="检出人"/>
          <el-table-column prop="create_out_time" label="检出时间"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="使用处" name="usedBy">
        <el-table :data="usedByDocList">
          <el-table-column type="index" label="序号" width="80"/>
          <el-table-column prop="name" label="名称"/>
          <el-table-column prop="doc_type_name" label="类型"/>
          <el-table-column prop="ref_count" label="使用数量"/>
          <el-table-column prop="version" label="版本号"/>
          <el-table-column prop="status_name" label="版本状态"/>
          <el-table-column prop="checkout_out_status_name" label="检出状态"/>
          <el-table-column prop="checkout_user_name" label="检出人"/>
          <el-table-column prop="create_out_time" label="检出时间"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="版本" name="version">
        <el-table :data="versionList">
          <el-table-column prop="version" label="版本号"/>
          <el-table-column prop="status_name" label="版本状态"/>
          <el-table-column prop="check_out_status_name" label="检出状态"/>
          <el-table-column prop="check_out_user_name" label="检出人"/>
          <el-table-column prop="check_out_time" label="检出时间"/>
          <el-table-column prop="create_user_name" label="创建时间"/>
          <el-table-column prop="create_time" label="创建人"/>
          <el-table-column label="操作"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="相关工作流">
        相关工作流
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "ModelDocTab",
  props: {
    docData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      activeTabName: 'attr',
      versionList: [],
      usedDocList: [],
      usedByDocList: [],
      attrList: []
    }
  },
  computed: {
    isFolder() {
      return this.docData.doc_type_id === 'folder'
    }
  },
  async created() {
    console.log('create', this.docData.id)
    if (!this.isFolder) {
      let data = await this.$http('pdmModelDocService.getDocDetail', {id: this.docData.id})
      console.log(data)
      this.attrList = data?.attrList;
      this.usedDocList = data?.usedDocList;
      this.usedByDocList = data?.usedByDocList;
      this.versionList = data?.versionList;
    }

  }
}
</script>

<style scoped>
.model-doc-tab {
  background-color: #FFFFFF;
  height: 100%;
}

.el-tabs, .el-tab-pane, .frame {
  height: 100%;
}


</style>